import { OnlyLoggedOut } from 'components/auth/Redirects';
import A1ConnectLandingPageLyceensMetiersCampagne from 'components/landing-pages/a1connect-landing-page-lyceens-metiers';
import { INSCRIPTION_LYCEEN_PATH } from 'lib/paths';
import JeuneVeloSrc from '../../../../public/img/landing-pages/campagne/illustration-jeune.png';
import { Box, Link } from '@chakra-ui/react';

const pageConfig = {
  inscriptionPath: INSCRIPTION_LYCEEN_PATH,
  profil: 'lyceen',
  lpPath: 'a1connect-1',
  ctaUrl: '/lyceen/a1connect-2',
  ctaLabel: 'Je fais le quiz',
  description: {
    header: 'Trouve le métier fait pour toi',
    text: 'Pour te guider vers des idées de métiers, INSPIRE t’aide d’abord à trouver des pistes d’études qui te correspondent.',
  },
  etapes: {
    title: 'Comment ça marche ?',

    etape1: {
      title: 'Réponds à notre quiz',
      text: 'Renseigne tes notes, tes envies. Des pistes d’études te seront recommandées en fonction de tes réponses !',
    },
    etape2: {
      title: 'Échange avec des étudiants',
      text: 'Avec des étudiants issus de formations qui t’intéressent, discute de leurs parcours. Leurs conseils te permettront de préparer ton entrée dans la vie étudiante.',
    },
  },
  chiffres: {
    pourcentage: '70%',
    text: 'C’est la part de lycéens qui ont découvert au moins une nouvelle formation',
    imageSrc: JeuneVeloSrc,
  },
  timelineContent: {
    heading: 'Comment ça marche ?',
    buttonSubtitle: 'Plus de 120 000 lycéens déjà inscrits',
    items: [
      {
        title: 'Réponds à notre quiz personnalisé',
        text: 'Renseigne tes notes, tes centres d’intérêt, tes envies… En fonction de tes réponses, des pistes d’études te seront suggérées avec quelques exemples de métiers.',
        imgURL: '/img/landing-pages/book.png',
      },
      {
        title: 'Échange avec des étudiants',
        text: 'Les Éclaireurs, étudiants issus de formations qui t’intéressent, répondent à tes questions sur leurs études et métiers auxquels elles mènent.',
        imgURL: '/img/landing-pages/textbox.png',
      },
    ],
  },
  testimonials: [
    {
      _id: 1,
      description:
        'Je ne savais pas comment m’y prendre pour trouver un métier fait pour moi. J’ai essayé INSPIRE et j’y ai déjà vu plus clair dans mes choix d’études, c’était une bonne base pour m’informer sur les débouchés métiers proposés.',
      author: 'Ahmed, Terminale Générale',
    },
    {
      _id: 2,
      description:
        'C’est super de découvrir une nouvelle plateforme et de nouvelles façons de s’informer sur notre orientation surtout quand on est totalement perdu face à ça et que c’est difficile de se motiver à chercher. Donc avoir une plateforme claire c’est bien.',
      author: 'Nina, Première Générale',
    },
    {
      _id: 3,
      description:
        'Très bonne idée cette plate-forme : parler à des étudiants en formation est un plus pour le choix d’orientation.',
      author: 'Alex, Terminale SMTG',
    },
  ],
  QAContent: [
    {
      id: 1,
      question: "INSPIRE c'est gratuit ?",
      answer:
        'L’accès à INSPIRE est entièrement gratuit et restera gratuit. Le site INSPIRE est à but non lucratif, nos recommandations sont neutres et ne sont pas influencées.',
    },
    {
      id: 2,
      question: "Qu’est ce qu'une piste d’études ?",
      answer: (
        <>
          <Box mb={3}>
            Les pistes d’études d’INSPIRE représentent les différents domaines
            d’études qui s’offrent à toi après le bac. Le questionnaire que tu
            remplis au moment de l’inscription nous permet de te recommander les
            pistes d’études qui semblent le plus te correspondre.
          </Box>
          <Box>
            Notre algorithme de recommandation est conçu avec une équipe de
            chercheurs de différents domaines et un conseil scientifique composé
            d'enseignants chercheurs experts en Psychologie, en Orientation et
            science de l’Éducation.
          </Box>
        </>
      ),
    },
    {
      id: 3,
      question: 'Qui sont les étudiants Éclaireurs ?',
      answer: (
        <>
          Les Éclaireurs sont des étudiants qui s'engagent bénévolement à
          partager avec les lycéens leur vécu et leur expérience dans différents
          domaines d'études. Sur INSPIRE, ils témoignent en discutant avec les
          lycéens qui prennent contact avec eux. Ils peuvent également
          participer aux différents événements organisés par l'association{' '}
          <Link isExternal href="https://article-1.eu/nos-metiers/">
            Article 1
          </Link>
          , dans des lycées et établissements d'enseignement supérieur.
        </>
      ),
    },
  ],
};

const LyceenLandingPageIntermediaireCampagne = () => {
  return <A1ConnectLandingPageLyceensMetiersCampagne pageConfig={pageConfig} />;
};

LyceenLandingPageIntermediaireCampagne.getWrappers = (page) => (
  <OnlyLoggedOut>{page}</OnlyLoggedOut>
);

export default LyceenLandingPageIntermediaireCampagne;
